import React from 'react'
import { Button } from 'react-bootstrap'
import GrowthWheelWorks from '../../components/GrowthWheelWorks/GrowthWheelWorks'
import GrowthWheelVisualizer from '../../components/GrowthWheelVisualizer/growth-wheel-visualizer'
import CompetencyAreaCard from '../../components/GrowthWheelCards/competency-area-card'
import { CompetencyArea, GrowthWheel } from '../../types/GrowthWheel'
import { getCompletedCompetencies, getTotalCompetencies } from '../../utils/growth-wheel-utils'

interface GrowthWheelDashboardProps {
  growthWheelData: GrowthWheel
  isLoading: boolean
  userCompetencyAreasData: CompetencyArea[]
  handleClickCompetencyArea: (competencyArea: CompetencyArea | null) => void
}

const GrowthWheelDashboard = ({ growthWheelData, isLoading, userCompetencyAreasData, handleClickCompetencyArea }: GrowthWheelDashboardProps) => {

  return (
    <div className="container mb-5 gw-growth-wheel-container">
      <div className="my-5">
        <h1 className='gw-growth-wheel-title'>Growth Wheel</h1>
        <p>Reflect on your competencies and prepare for meaningful growth conversations.</p>
      </div>
      <div className='row'>
        <div className='col-10 col-md-6 gw-visualizer-container'>
          {isLoading ? (
            <div>Loading...</div>
          ) : (<>
            <GrowthWheelVisualizer imageUrl={growthWheelData?.imageUrl || undefined} />
            <GrowthWheelWorks />
          </>
          )}
        </div>
        <div className='col-12 col-md-8 gw-competency-area-cards-container'>
          <div className='gw-competency-area-cards-header'>
            <h3 className='gw-competency-area-cards-header-title'>Competency Areas</h3>
            <Button>Continue Assessment</Button>
          </div>

          <div className='gw-competency-area-list'>
            {userCompetencyAreasData.map((competencyArea) => (
              <CompetencyAreaCard
                key={competencyArea.id}
                title={competencyArea.name}
                description={competencyArea.description}
                onClick={() => handleClickCompetencyArea(competencyArea)}
                completed={getCompletedCompetencies(competencyArea.competencies ?? [])}
                total={getTotalCompetencies(competencyArea.competencies ?? [])}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GrowthWheelDashboard